var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('v-skeleton-loader',{staticClass:"px-4 py-3 mr-4",attrs:{"type":"avatar"}}),_vm._v(" "),_c('v-skeleton-loader',{staticClass:"px-4 py-3",attrs:{"width":"100%","type":"table-row"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }